import { Information } from '@depop/web-thrift-ui/Icons/Information';
import { Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

type Props = {
  className?: string;
};

export function SellerInactiveDisclaimer({ className }: Props) {
  const t = useTranslations('product');

  return (
    <div className={clsx(className, styles.container)} role="note">
      <Information size="sm" aria-hidden="true" />
      <Caption variant="lg-regular" colour="base" className={styles.text}>
        {t('SellerInactiveDisclaimer')}
      </Caption>
    </div>
  );
}
